import flood from 'assets/FloodStageIcons/stage_online.png';
import floodcam from 'assets/FloodStageIcons/stage_online_camera.png';
import BaseMap from 'components/BaseMap/BaseMap';
import useLocation from 'hooks/useLocation';
import L from 'leaflet';
import React, { useEffect, useState } from 'react';
import { Button, Card, Container } from 'react-bootstrap';
import { Circle, Marker, Popup } from 'react-leaflet';
import { GetDeviceTypeString } from 'utils/strings/string.utils';

const floodIcon = L.icon({
  iconUrl: flood,
  iconSize: [25, 41],
});

const floodCameraIcon = L.icon({
  iconUrl: floodcam,
  iconSize: [25, 41],
});

export default function RadialAlertMap({
  arrayOfDevices,
  selectedDevice,
  radius,
  setSelectedDevice,
}) {
  const { locations } = useLocation();
  const workplaceLocation = locations.workplaceLocation;
  const fallbackCoordinates = workplaceLocation.coords;
  const [userPosition, setUserPosition] = useState(fallbackCoordinates);

  const [mapCenter, setMapCenter] = useState(fallbackCoordinates);

  useEffect(() => {
    if (selectedDevice && selectedDevice.location.lat && selectedDevice.location.lng) {
      setMapCenter([selectedDevice.location.lat, selectedDevice.location.lng]);
    }
  }, [selectedDevice]);

  useEffect(() => {
    setUserPosition(workplaceLocation.coords);

    if (navigator?.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = [position.coords.latitude, position.coords.longitude];
          setUserPosition(coords);
        },
        () => {
          setUserPosition(workplaceLocation.coords);
        },
      );
    }
  }, [workplaceLocation]);

  return (
    <Container fluid className="p-0">
      {userPosition && (
        <div className="d-flex justify-content-center">
          <div
            className="position-relative w-100 rounded-2 shadow overflow-hidden"
            style={{ height: 'clamp(320px, 50vh, 640px)' }}
          >
            <BaseMap
              mapCenter={mapCenter}
              zoom={13}
              className="position-absolute top-0 start-0 w-100 h-100"
              disableMapReset
            >
              <Marker position={userPosition}>
                <Popup>
                  <div className="fw-semibold">Your location</div>
                </Popup>
              </Marker>

              {selectedDevice && <Circle center={mapCenter} radius={radius * 0.3048} />}

              {arrayOfDevices
                .filter((f) => GetDeviceTypeString(f).toLowerCase() === 'flood stage')
                .filter((device) => device.location?.lat && device.location?.lng)
                .map((device) => (
                  <Marker
                    key={device.node_id}
                    position={[device.location.lat, device.location.lng]}
                    icon={
                      device.imgList && device.imgList.length > 0 && device.imgList[0].url
                        ? floodCameraIcon
                        : floodIcon
                    }
                  >
                    <Popup>
                      <Card className="border-0">
                        <Card.Body className="p-2">
                          <Card.Title className="h6 mb-2">Node ID: {device.node_id}</Card.Title>
                          <div className="small text-muted">
                            <div>Status: {device.status}</div>
                            <div>Type: {device.type}</div>
                          </div>

                          {device.imgList && device.imgList.length > 0 && device.imgList[0].url && (
                            <div className="mt-2">
                              <img
                                src={device.imgList[0].url}
                                alt="Device"
                                className="img-fluid rounded"
                                style={{ maxHeight: 120, objectFit: 'cover' }}
                              />
                            </div>
                          )}

                          <Button
                            variant="primary"
                            size="sm"
                            className="w-100 mt-2"
                            onClick={() => setSelectedDevice(device.node_id)}
                          >
                            Use this device
                          </Button>
                        </Card.Body>
                      </Card>
                    </Popup>
                  </Marker>
                ))}
            </BaseMap>
          </div>
        </div>
      )}
    </Container>
  );
}
